import { ThemeProvider as MuiThemeProvider } from "@mui/material"
import { PropsWithChildren } from "react"

import { useTheme } from "@/theme"

import { themes } from "../theme/theme"

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const { themeName } = useTheme()

  return (
    <MuiThemeProvider theme={themes[themeName]}>{children}</MuiThemeProvider>
  )
}
